

import request from '@/util/http'



// 留言列表查询
export const getLeaveMsgList=(params)=>request({
    url: '/admin/personalCenter/leaveMsg/list',
    method: 'get',
    params
})



// 留言详情
export const getLeaveMsgDetail=(params)=>request({
    url: '/admin/personalCenter/leaveMsg/detail',
    method: 'get',
    params
})


// 留言详情
export const getLeaveMsgRepeat=(params)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/personalCenter/leaveMsg/repeat',
    method: 'post',
    data:JSON.stringify(params)
})

// 留言列表查询
export const getAdviceList=(params)=>request({
    url: '/admin/personalCenter/advice/list',
    method: 'get',
    params
})

// 留言列表查询
export const getAdviceTypeList=()=>request({
    url: '/admin/personalCenter/advice/type/list',
    method: 'get',
})
